<template>
    <v-dialog
        :value="isOpen"
        max-width="500px"
        max-height="600px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onAbort"
        @click:outside="onAbort"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Zmiana Statusu
                </h1>
            </v-card-title>
            <v-card-text class="text-center">
                <v-select
                    v-model="accidentStatusId"
                    :items="accidentStatuses"
                    item-value="id"
                    placeholder="Wybierz status..."
                    no-data-text="Nie znaleziono statusu"
                    label="Status"
                >
                    <template slot="selection" slot-scope="data">
                        {{ data.item.name }}
                    </template>

                    <template slot="item" slot-scope="data">
                        {{ data.item.name }}
                    </template>
                </v-select>
                <v-textarea
                    v-model="comment"
                    name="Komentarz"
                    label="Komentarz"
                />
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    :disabled="loading"
                    data-sentry-label="Anuluj"
                    @click="onAbort"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    :disabled="disableConfirmButton"
                    :loading="loading"
                    data-sentry-label="Potwierdź"
                    @click="saveAssignStatus"
                >
                    Potwierdź
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: 'AssignStatusDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        accident: {
            type: Object,
            default: null
        },
        loading: {
            type: Boolean
        },
        canUpdateDeclaredFixedTime: {
            type: Boolean
        },
    },
    data() {
        return {
            accidentStatusId: null,
            comment: null,
            excludeStatuses: [1, 20, 30] //['Zgłoszona', 'W trakcie usuwania', 'Przekierowana']
        }
    },
    computed: {
        accidentStatuses() {
            return this.$store.state.maintenance.accidents.accidentStatuses.filter(item => !this.excludeStatuses.includes(item.id))
        },
        disableConfirmButton() {
            return (this.excludeStatuses.includes(this.accidentStatusId)) ? true : false
        },
    },
    watch: {
        accident(value) {
            this.accidentStatusId = value.accidentStatusId
            this.comment = value.accidentStatusHistory.comment
        }
    },
    methods: {
        saveAssignStatus() {
            this.$emit('save-assign-status', {
                updateType: 'status',
                accidentStatusId: this.accidentStatusId,
                comment: this.comment
            })
        },
        onAbort() {
            this.accidentStatusId = this.accident.accidentStatusId
            this.comment = this.accident.comment
            this.$emit('close-assign-status-dialog')
        },
    }
}
</script>